module.exports = "<html>\r\n  <body>\r\n    <p>Ho</p>\r\n  </body>\r\n</html>";